import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  makeStyles
} from '@material-ui/core'
import deburr from 'lodash.deburr'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import searchIcon from '../../assets/images/search.svg'
import SoldMovieTickets from '../../components/SoldMovieTickets'
import Context from '../../context'
import { addOrEditMovieTickets, getMovieTicketsGroups } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function MovieTicketsList() {
  const classes = useStyles()
  const { setUser } = useContext(Context)
  const { setAboutCurrentPage } = useContext(Context)
  const [data, setData] = useState(null)
  const [finalData, setFinalData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState('0')
  const [query, setQuery] = useState('')
  const [deleteModalData, setDeleteModalData] = useState(null)
  const [publishModalData, setPublishModalData] = useState(null)
  const [soldDrawerData, setSoldDrawerData] = useState(null)

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')

    setUser(getLoggedUser)
    getData()
    setAboutCurrentPage({
      title: 'Ingressos de cinema',
      buttons: [
        {
          title: 'Novo grupo',
          pathname: '/movieticketsform'
        },
        {
          title: 'Vendas',
          pathname: '/movieticketspurchases'
        }
      ]
    })
  }, [])

  useEffect(() => {
    if (!data) return

    const filtered = data.filter(item =>
      new RegExp(deburr(query), 'i').test(deburr(item.Partner.fantasyName))
    )
    const resorted = {
      0: () => filtered,
      1: () =>
        filtered.sort((one, another) => new Date(another.validDate) - new Date(one.validDate)),
      2: () =>
        filtered.sort((one, another) =>
          one.Partner.fantasyName.localeCompare(another.Partner.fantasyName)
        )
    }[sortBy]()
    setFinalData(resorted)
  }, [sortBy, query])

  useEffect(() => {
    console.log(finalData)
  }, [finalData])

  async function getData() {
    try {
      setLoading(true)
      const data = await getMovieTicketsGroups()
      setData(data)
      setFinalData(data)
    } catch {
      //
    } finally {
      setLoading(false)
    }
  }

  function handleSortByChange(e) {
    setSortBy(e.target.value)
  }

  function handleQueryChange(e) {
    setQuery(e.target.value)
  }

  function setToBeDeleted(item) {
    return function () {
      setDeleteModalData(item)
    }
  }

  function setToBePublished(item) {
    return function () {
      setPublishModalData(item)
    }
  }

  function hideDeleteModal() {
    setDeleteModalData(null)
  }

  function hidePublishModal() {
    setPublishModalData(null)
  }

  function showSoldTickets(item) {
    setSoldDrawerData(item)
  }

  function hideSoldTickets() {
    setSoldDrawerData(null)
  }

  function saveData(situation) {
    return async function (item) {
      try {
        setDeleteModalData(null)
        setData([])
        setLoading(true)
        await addOrEditMovieTickets({
          ...item,
          situation
        })
        await getData()
      } catch {
        //
      }
    }
  }

  const publishItem = saveData(1)
  const deleteItem = saveData(2)

  function formatNumber(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  }

  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.row}>
            <div className={classes.filters}>
              <div className={classes.actions} />
              <select className={classes.sorting} value={sortBy} onChange={handleSortByChange}>
                <option disabled value="0">
                  Ordenar por:
                </option>
                <option value="1">Data de validade</option>
                <option value="2">Parceiro</option>
              </select>
            </div>
            <input
              className={classes.search}
              value={query}
              onChange={handleQueryChange}
              placeholder="Buscar..."
            />
          </div>
          <table className={classes.table}>
            <colgroup>
              <col />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
            </colgroup>
            <thead>
              <tr>
                <td>Parceiro</td>
                <td>Titulo do Voucher</td>
                <td>Tipo</td>
                <td>Quantidade</td>
                <td>Status</td>
                <td>Valor de venda</td>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                finalData?.map(item => (
                  <tr key={item.id}>
                    <td className={classes.titleContainer}>
                      <div>{item.Partner.fantasyName}</div>
                      <div>
                        <Link
                          to={{
                            pathname: '/movieticketsform',
                            state: { itemToEdit: item }
                          }}
                        >
                          Editar
                        </Link>
                        {' | '}
                        {item.situation === 1 && <a onClick={setToBeDeleted(item)}>Suspender</a>}
                        {item.situation === 3 && <a onClick={setToBePublished(item)}>Publicar</a>}
                      </div>
                    </td>
                    <td>{item.movieType}</td>
                    <td>
                      {
                        {
                          films: 'Filmes',
                          others: 'Outros'
                        }[item.roomType]
                      }
                    </td>
                    <td className={classes.quantityContainer}>
                      <div>
                        {item.MovieTickets.filter(ticket => ticket.status === 1).length}/
                        {item.MovieTickets.length}
                      </div>
                      <div>
                        <a onClick={() => showSoldTickets(item)}>Ver detalhes</a>
                      </div>
                    </td>
                    <td>
                      {
                        {
                          1: 'Publicado',
                          3: 'Rascunho'
                        }[item.situation]
                      }
                    </td>
                    <td>{formatNumber(item.value)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        </div>
      </div>

      <SoldMovieTickets info={soldDrawerData} open={!!soldDrawerData} onClose={hideSoldTickets} />

      <Dialog
        open={!!deleteModalData}
        onClose={hideDeleteModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Suspender grupo de ingresso</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja realmente suspender o grupo?</DialogContentText>
          <DialogContentText>A ação não pode ser desfeita.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideDeleteModal}>
            Não
          </Button>
          <Button color="primary" onClick={() => deleteItem(deleteModalData)}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!publishModalData}
        onClose={hidePublishModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Publicar grupo de ingresso</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja realmente publicar o grupo?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hidePublishModal}>
            Não
          </Button>
          <Button color="primary" onClick={() => publishItem(publishModalData)}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  filters: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    marginRight: 30,
    padding: '12px 10px 10px',
    borderBottom: '2px solid #30287b'
  },
  sorting: {
    height: '100%',
    fontSize: '12px',
    color: '#30287b',
    border: 'none',
    '& option:disabled': {
      display: 'none'
    }
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  titleContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      },
      '& a:last-child': {
        color: '#d73f32'
      }
    }
  },
  quantityContainer: {
    '& div:first-child': {
      marginBottom: '17px'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      }
    }
  }
})

export default MovieTicketsList
